const {
  SOURCE_ERFTLW,
} = require('./../../../../sourceList')
const {
  CR_1,
} = require('./../../../../crList')
const {
  SIZE_MEDIUM,
} = require('./../../../../sizeList')
const {
  CREATURE_TYPE_CONSTRUCT,
  CREATURE_TYPE_HOMUNCULUS,
} = require('./../../../../creatureTypeIdList')
const {
  SKILL_PERCEPTION,
  SKILL_STEALTH,
} = require('./../../../../skillList')
const {
  ALIGNMENT_N,
} = require('./../../../../aligmentList')
const {
  SPEED_WALK,
} = require('./../../../../speedList')
const {
  ATTACK_MELEE_WEAPON,
} = require('./../../../../attackTypeList')
const {
  DAMAGE_PIERCING,
  DAMAGE_POISON,
} = require('./../../../../damageTypeList')
const {
  LANG_ITS_CREATOR,
} = require('./../../../../languageIdList')
const {
  SENSE_DARK_VISION,
} = require('./../../../../senseList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  ABILITY_KEEN_SMELL,
  ABILITY_TELEPATHIC_BOND,
} = require('./../../../../creatureAbilityList')
const {
  ARMOR_TYPE_NATURAL,
} = require('./../../../../armorTypeList')
const {
  CONDITION_EXHAUSTION,
  CONDITION_POISONED,
} = require('./../../../../conditionList')
const {
  PROF_NORMAL,
} = require('./../../../../proficiencyList')
const {
  INFUSION_HOMUNCULUS_SERVANT,
} = require('./../../../../infusionIdList')
const {
  SPELL_CREATE_HOMUNCULUS,
} = require('./../../../../spellIdList')
const {
  homunculiDescriptionList,
} = require('./../../../../textCommonParts')
const {
  CREATURE_IRON_DEFENDER,
} = require('./../../../../creatureIdList')

module.exports = {
  name: 'Железный защитник',
  nameEn: 'Iron Defender',
  id: CREATURE_IRON_DEFENDER,
  createdBySpellId: SPELL_CREATE_HOMUNCULUS,
  createdByInfusionId: INFUSION_HOMUNCULUS_SERVANT,
  description: [
    `Железный защитник сражается за своего создателя.

Они бывают множества форм и часто создаются в виде животного. Более креативные изобретатели создают железных защитников в форме гибрида животных или фантастического существа.`,
    ...homunculiDescriptionList,
  ],
  sizeType: SIZE_MEDIUM,
  creatureTypeIdList: [
    CREATURE_TYPE_CONSTRUCT,
    CREATURE_TYPE_HOMUNCULUS,
  ],
  alignmentId: ALIGNMENT_N,
  source: {
    id: SOURCE_ERFTLW,
    page: 294,
  },
  armor: {
    ac: 17,
    type: ARMOR_TYPE_NATURAL,
  },
  hp: {
    diceCount: 4,
  },
  speed: {
    [SPEED_WALK]: 40,
  },
  params: {
    [PARAM_STR]: 16,
    [PARAM_DEX]: 14,
    [PARAM_CON]: 16,
    [PARAM_INT]: 8,
    [PARAM_WIT]: 11,
    [PARAM_CHA]: 7,
  },
  skillCollection: {
    [SKILL_PERCEPTION]: PROF_NORMAL,
    [SKILL_STEALTH]: PROF_NORMAL,
  },
  immunityList: [
    DAMAGE_POISON,
  ],
  immunityConditionList: [
    CONDITION_EXHAUSTION,
    CONDITION_POISONED,
  ],
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 60,
    },
  ],
  languageList: [
    {
      id: LANG_ITS_CREATOR,
      doNotSpeak: true,
    },
  ],
  cr: CR_1,
  featureList: [
    ABILITY_KEEN_SMELL,
    ABILITY_TELEPATHIC_BOND,
  ],
  actionList: [
    {
      name: 'Укус',
      description: `Если цель — существо, она должна пройти испытание Силы СЛ 13 или получить дополнительно 3 (1к6) колющего урона и стать Схваченной (СЛ побега 13). ★СУЩЕСТВО★ может держать Схваченным таким образом только одно существо одновременно.`,
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 5,
        range: 5,
        hit: {
          type: DAMAGE_PIERCING,
          diceCount: 1,
          diceType: 6,
          diceBonus: 3,
        },
      },
    },
  ],
}
